const VINDecoder: {
  [key: string]: {
    name: string;
    codes: { [key: string]: any };
  };
} = {
  '1-3': {
    name: 'World Manufacturer Identifier (WMI)',
    codes: {
      '5YJ': { manufacturer: 'Tesla, Inc.', country: 'USA' },
      '7SA': { manufacturer: 'Tesla, Inc.', country: 'China' },
      LRW: { manufacturer: 'Tesla, Inc.', country: 'China (Giga Shanghai)' },
      XP7: { manufacturer: 'Tesla, Inc.', country: 'Germany (Giga Berlin)' },
    },
  },

  '4': {
    name: 'Line/Series',
    codes: {
      S: 'Model S',
      '3': 'Model 3',
      X: 'Model X',
      Y: 'Model Y',
      C: 'Cybertruck',
      R: 'Roadster',
    },
  },
  '5': {
    name: 'Body type',
    codes: {
      G: 'MPV 5 DR / LHD',
      H: 'MPV 5 DR / RHD',
    },
  },
  '6': {
    name: 'Restraint system',
    codes: {
      A: 'Type 2 Manual seatbelts (FR, SR*3, TR*2) with front Airbags, PODS, side Inflatable restraints, Knee Airbags',
      D: 'Type 2 Manual seatbelts (FR, SR*3) with front Airbags, PODS, side Inflatable restraints, Knee Airbags',
      C: 'Type 2 Manual seatbelts with front Airbags, PODS, side Inflatable restraints',
    },
  },

  '7': {
    name: 'Fuel type',
    codes: {
      E: 'Electric (Fremont-built vehicles), Ternary System Li-ion battery (Giga Shanghai-built vehicles)',
      L: 'Lithium Iron Phosphate Battery (Giga Shanghai-built vehicles only)',
    },
  },

  '8': {
    name: 'Motor/Drive unit',
    codes: {
      D: 'Single Motor Standard',
      E: 'Dual Motor Standard',
      F: 'Dual Motor Performance (3DU 800A)',
      J: 'Single Motor Standard',
      K: 'Dual Motor Standard',
      L: 'Dual Motor Performance',
      R: 'Single Motor Standard (3DU 600A)',
      S: 'Single Motor Standard (DUB 600A)',
    },
  },

  '10': {
    name: 'Year',
    codes: {
      A: 2010,
      B: 2011,
      C: 2012,
      D: 2013,
      E: 2014,
      F: 2015,
      G: 2016,
      H: 2017,
      J: 2018,
      K: 2019,
      L: 2020,
      M: 2021,
      N: 2022,
      P: 2023,
      R: 2024,
      S: 2025,
    },
  },
  '11': {
    name: 'Assembly plant',
    codes: {
      A: 'Tesla Austin, TX (USA)',
      B: 'Tesla Berlin (Germany)',
      C: 'Tesla China (Giga Shanghai)',
      F: 'Tesla Fremont, CA (USA)',
    },
  },
};

export function decodeVIN(vin: string): { [key: string]: string } {
  if (vin.length !== 17) return { error: 'Invalid VIN length' };

  const wmi = vin.substring(0, 3);
  const yearCode = vin[9];
  const plantCode = vin[10];

  return {
    '1-3': VINDecoder['1-3'].codes[wmi].manufacturer || 'Unknown',
    '4': VINDecoder['4'].codes[vin[3]] || 'Unknown Line/Series',
    '5': VINDecoder['5'].codes[vin[4]] || 'Unknown Body type',
    '6': VINDecoder['6'].codes[vin[5]] || 'Unknown Restraint system',
    '7': VINDecoder['7'].codes[vin[6]] || 'Unknown Fuel type',
    '8': VINDecoder['8'].codes[vin[7]] || 'Unknown Motor/Drive unit',
    '10': VINDecoder['10'].codes[yearCode] || 'Unknown Year',
    '11': VINDecoder['11'].codes[plantCode] || 'Unknown Assembly plant',
  };
}
